import React from 'react'

import { StatusTag } from '@components/common/StatusTag'
import { VirtualProductThumbnail } from '@components/common/VirtualProductThumbnail'
import { useDashboardPermissions } from '@components/utils/DashboardPermissions'
import { TableItemDate } from '@components/utils/TableItemDate'
import { PriceString, ProfitString } from '@fourthwall/components'

import type { Status } from '../../../../../../../../../../consts/status'
import type { Donation } from '../../DonationsList.types'
import * as S from './DonationListItem.styled'

type DonationListItemProps = {
  donation: Donation
}

export const DonationListItem = ({ donation }: DonationListItemProps) => {
  const { hasPermission } = useDashboardPermissions()

  return (
    <S.Container>
      <S.Photo>
        <VirtualProductThumbnail />
      </S.Photo>
      <S.Details>
        <S.Supporter>{donation.username || donation.email}</S.Supporter>
        <S.Date>
          <TableItemDate date={donation.createdAt} />
        </S.Date>
        <StatusTag status={donation.status as Status} />
      </S.Details>
      <S.Calculations>
        <PriceString value={donation.donation.value} />
        {hasPermission('contributions.profit') && donation.profit && (
          <S.Profit>
            <ProfitString value={donation.profit.value} />
          </S.Profit>
        )}
      </S.Calculations>
    </S.Container>
  )
}
